import Vue from 'vue';

import {
    MODEL_TYPES,
    MODEL_TO_STATE,
} from '@/lib/constants/model-types';

import {
    VALIDATION_STATES,
    UNPROCESSED,
} from '@/lib/constants/validations';

import {
    STOP_FORM,
    ADD_MODEL_OF_TYPE,
    INIT_FLOW_MANAGER,
    SETUP_FLOW_MANAGER,
    SET_CURRENT_STEP,
    CHANGE_VALIDATIONS_STATES,
    CHANGE_VALUE_FIELD,
    CREATE_VALUE_FIELD,
    INIT_VALIDATION,
    ADD_STEP_TO_HISTORIC,
    DELETE_LAST_FROM_HISTORIC,
    CLEAR_HISTORIC_UNTIL_STEP,
    RESET_FORM,
    ROUTE_CHANGE_FORM,
    ROUTE_GO_TO_END_PAGE,
    SET_RESPONSE_PARAMS,
    CLEAR_ALL_HISTORIC,
    MODAL_OVERLAY,
    SET_APP_ID,
    SET_SHOW_API_PANEL,
    UPDATE_MODEL_OF_TYPE,
    SET_SERVICE_STATUS,
    SET_SERVICE_STATUS_REFERAL,
    SET_MAX_LOAN,
    SET_MONTHLY_INSTALMENTS,
    SET_TRANSACTION_ID,
    SET_TRANSACTION_DECISION,
    RESET_TRANSACTION_DECISION,
    SET_INSTITUTIONS,
    SET_UPLOADED_OCR,
    SET_LAST_VISITED_PAGE,
    ADD_SUPPLEMENTARY_CARD,
    SET_CURRENT_PRODUCT,
    EDIT_SUPPLEMENTARY_CARD,
    REMOVE_SUPPLEMENTARY_CARD,
    SET_QUERYSTRING,
    SET_CIF_NUMBER,
    SET_INSTALMENT_AMOUNT,
    SET_UTM_SOURCE,
    SET_UTM_MEDIUM,
    SET_UTM_CAMPAIGN,
    SET_UTM_CONTENT,
    SET_UTM_PRODUCT_ID,
    SET_BANK_NAME,
    SET_CREDIT_SCORE_STATUS,
    SET_DOC_NUMBER,
    SET_DOC_TYPE,
    SET_FIRST_NAME,
    SET_SECOND_NAME,
    SET_BASIC_ELIGIBILITY,
    SET_PRODUCT_TYPE,
    SET_USE,
    SET_HOW_MUCH,
    SET_INSTALMENT,
    SET_OTHER,
    SET_CONSOLIDATED_STATEMENT_DATA,
    SET_STATEMENT_ONE_DATA,
    SET_STATEMENT_TWO_DATA,
    SET_STATEMENT_THREE_DATA,
    SET_CREDIT_SCORE_CALCULATION_STATUS,
    SET_PRODCUT_FROM_URL,
    SET_SPENDING,
    SET_SALARY_RECEIVE,
    SET_REWARD_TYPE,
    SET_CASH_BACK_POINT,
    SET_TEN_TO_TWENTY_FIVE,
    SET_MORE_THAN_TWENTY_FIVE,
    SET_INELIGIBLE_EMIRATES,
    SET_EMPLOYMENT_TYPE,
    SET_SERVICE_ERROR,
    SET_CARD_TYPE,
    SET_LOAN_TYPE,
    SET_PROMO_CODE_RESPONSE,
    SET_PROMO_CODE_STATUS,
    SET_BRANCH_CODES,
    SET_EMPLOYEE_CODES,
    SET_PRODUCTS,
    SET_INELIGIBLE_MEDIUM_OF_RECEIVE,
    SET_APPIAN_PERSONAL_INFO_RESPONSE,
    SET_APPIAN_IDENTITY_INFO_RESPONSE,
    SET_APPIAN_EMP_INFO_RESPONSE,
    SET_APPIAN_INCOME_INFO_RESPONSE,
    SET_PRODUCT_FROM_API_RESPONSE,
    SET_OFFER_REJECTED,
    SET_IS_PERFIOS_ERROR,
    SET_PERFIOS_ERROR_MESSAGE,
    SET_AGENT_MOBILE,
    SET_CARD_TYPE_APPIAN,
    SET_STP_CARD_INCOME_NEXT,
    SET_PRE_SCREENED_AMOUNT,
    SET_VARIABLE_INCOME,
    SET_STP_PRE_SCREENED_AMOUNT,
    SET_CHANNEL,
    SET_ACCUITY_RESPONSE,
    SET_UAE_VINTAGE,
    SET_CIF_ERROR,
    SET_CUSTOMER_CONSENT,
    SET_JOB_VINTAGE,
    SET_CUSTOMER_EXIST,
    SET_CIF_ERROR_COUNT,
    SET_CC_SCORE_RESPONSE,
    SET_APPLICATION_STATUS,
    SET_MAX_CREDIT_LIMIT,
    SET_REFERAL_CIF,
    SET_CREDIT_SCORE_CALCULATION_RES,
    SET_ADDRESS_COUNT,
    ADD_BALANCE_TRANSFER,
    EDIT_BALANCE_TRANSFER,
    REMOVE_BALANCE_TRANSFER,
    SET_BUREAU_SCORE,
    SET_INCOME_FIXED,
    SET_BANK_NAMES,
    SET_BT_TRANSFER_LIMIT,
    SET_LIMIT_EXCEEDED,
    SET_AUTOMATION_RESPONSE,
    SET_DEEMGUARD_CREDITLIFEPLUS,
    SET_DEEM_DOUBLESECURE_LOANPROTECT

} from '@/lib/constants/mutations';

import FormException from '@/lib/exceptions/form-exception';

import {
    STEP_ROUTE_TYPE,
    END_PAGE_ROUTE_TYPE,
} from '@/lib/constants/routes';

import PERFIOS_TRANSACTION from '@/lib/constants/store';
import { basicEligibility } from '@/forms/helpers/basic-eligibility';

const fieldsForStore = {
    formData: {
        initForm: false,
        currentStepName: null,
        formHistoric: null,
        routing: {
            type: null,
            formName: null,
        },
        mainFormName: null,
        values: {},
        lastEditValues: {},
        validationStates: {},
        [PERFIOS_TRANSACTION]: {
            duniaIncomeVerificationId: '',
            vendorIncomeVerificationId: '',
        },
        services: {},
        servicesReferal: {},

        OCRUpdatedFields: false,
        monthlyInstalmentsOptions: [],
        maxLoan: 14000,
        supplementaryCards: [],
        balanceTransfers: [],
    },
    modalOverlay: false,
    responseOptions: [],
    appId: null,
    showApiPanel: false,
    lastEditValues: {},
    mainFormName: null,
    institutions: [],
    lastVisitedPage: null,
    cifnumber: null,
    monthlyInstalment: null,
    source: null,
    medium: null,
    campaign: null,
    content: null,
    productId: null,
    bankName: null,
    creditScoreStatus: null,
    docNumber: null,
    firstName: null,
    lastName: null,
    basicEligibility5000: null,
    productType: null,
    use: null,
    howMuch: null,
    instalment: null,
    other: null,
    consolidatedSatement: null,
    statementOneData: null,
    statementTwoData: null,
    statementThreeData: null,
    creditScoreCalculationSatus: null,
    productTypeFromUrl: null,
    spending: null,
    salaryReceive: null,
    rewardType: null,
    cashBackPoint: null,
    tenToTwentyFive: null,
    moreThanTwentyFive: null,
    ineligibleEmirates: null,
    employmentType: null,
    serviceError: null,
    cardType: null,
    loanType: null,
    promoCodeResponse: null,
    promoCodeStatus: null,
    branchCodes: null,
    employeeCodes: null,
    products: null,
    appianPersonalInfo: null,
    appianIdentityInfo: null,
    appianEmpInfo: null,
    appianIncomeInfo: null,
    productTypeFromCreditScoreCalculation: null,
    offerRejected: null,
    isPerfiosError: null,
    agentMobileNumber: null,
    appianCardType: null,
    incomeInfoNext: null,
    preScreendedAmount: null,
    variableIncome: null,
    stpPreScreenedAmount: null,
    channel: null,
    accuityResponse: null,
    uaeVintage: null,
    isCifError: null,
    customerConsent: null,
    jobVintage: null,
    customerExist: null,
    cifErrorCount: null,
    ccScore: null,
    maxCreditLimit: null,
    applicationStatus: null,
    referalCif: null,
    creditScoreCalculationRes: null,
    addressCount: null,
    bureauScore: null,
    incomeFixed: null,
    bankList: [],
    btTrnsferLimit: null,
    limitExceeded: null,
    automationResponse: null,
    deemGuardCreditLife: null,
    deemDoubleSecureLoanProtect: null


};

Object.keys(MODEL_TO_STATE).forEach((modelType) => {
    fieldsForStore[MODEL_TO_STATE[modelType]] = {};
});

const changeValidationState = state => ({ name, newValidity }) => {
    const validationState = state.formData.validationStates[name];

    if (!VALIDATION_STATES.includes(newValidity)) {
        throw new FormException('Validity state is not defined');
    }

    validationState.validity = newValidity;
};

const formsState = fieldsForStore;

const formsMutations = {
    [CREATE_VALUE_FIELD](state, { name, defaultValue }) {
        const { values } = state.formData;

        if (!values[name]) {
            Vue.set(values, name, defaultValue);
        }
    },

    [INIT_VALIDATION](state, { name }) {
        const { validationStates } = state.formData;
        if (!validationStates[name]) {
            Vue.set(validationStates, name, {});
            Vue.set(validationStates[name], 'validity', UNPROCESSED);
        }
    },

    [CHANGE_VALUE_FIELD](state, {
        name,
        newValue,
        newValidationStates,
        edited,
    }) {
        Vue.set(state.formData.values, name, newValue);

        if (edited) {
            Vue.set(state.formData.lastEditValues, name, newValue);
        }

        const changer = changeValidationState(state);
        newValidationStates.forEach(changer);
    },

    [CHANGE_VALIDATIONS_STATES](state, { newValidationStates }) {
        const changer = changeValidationState(state);
        newValidationStates.forEach(changer);
    },

    [ADD_MODEL_OF_TYPE](state, { modelType, modelId, plainData }) {
        if (MODEL_TYPES.includes(modelType)) {
            const modelObj = state[MODEL_TO_STATE[modelType]];
            Vue.set(modelObj, modelId, {});

            const newObject = modelObj[modelId];

            Object.keys(plainData).forEach((key) => {
                Vue.set(newObject, key, plainData[key]);
            });
        } else {
            throw new FormException('Not valid model type to add');
        }
    },

    [UPDATE_MODEL_OF_TYPE](state, { modelType, modelId, newProperties }) {
        if (MODEL_TYPES.includes(modelType)) {
            const model = state[MODEL_TO_STATE[modelType]];
            const hasModelId = Object.prototype.hasOwnProperty.call(model, modelId);
            if (!hasModelId) {
                Vue.set(model, modelId, {});
            }
            const modelObj = model[modelId];

            Object.keys(newProperties).forEach((key) => {
                Vue.set(modelObj, key, newProperties[key]);
            });
        }
    },

    [INIT_FLOW_MANAGER](state, { currentStep }) {
        state.formData.initForm = true;
        if (currentStep) {
            state.formData.currentStepName = currentStep.name;
        }
        state.formData.formHistoric = [];
    },

    [SETUP_FLOW_MANAGER](state, { mainForm }) {
        state.formData.mainFormName = mainForm.name;
    },


    [STOP_FORM](state) {
        state.formData.initForm = false;
        state.formData.currentStepName = null;
        state.formData.formHistoric = null;
        state.forceStopForm = true;
        state.showEndPage = true;
    },

    [SET_CURRENT_STEP](state, { stepName }) {
        state.formData.currentStepName = stepName;
    },

    [RESET_FORM](state) {
        const { values } = state.formData;

        Object.keys(values).forEach((key) => {
            Vue.set(values, key, null);
        });
    },

    [ROUTE_CHANGE_FORM](state, { formName }) {
        state.formData.routing.formName = formName;
        state.formData.routing.type = STEP_ROUTE_TYPE;
    },

    [ROUTE_GO_TO_END_PAGE](state) {
        state.formData.routing.type = END_PAGE_ROUTE_TYPE;
    },

    [ADD_STEP_TO_HISTORIC](state, { stepName }) {
        state.formData.formHistoric = [...state.formData.formHistoric, stepName];
    },

    [DELETE_LAST_FROM_HISTORIC](state) {
        state.formData.formHistoric.pop();
    },

    [CLEAR_HISTORIC_UNTIL_STEP](state, { stepName }) {
        const { formHistoric } = state.formData;
        const stepIndex = formHistoric.indexOf(stepName);

        formHistoric.splice(stepIndex);
    },

    [SET_RESPONSE_PARAMS](state, response) {
        const newService = {...response };

        const filteredOptions = state.responseOptions
            .filter(serviceOptions => serviceOptions.serviceName !== newService.serviceName);

        state.responseOptions = [...filteredOptions, newService];
    },

    [CLEAR_ALL_HISTORIC](state) {
        state.formData.formHistoric = [];
    },

    [MODAL_OVERLAY](state, { display }) {
        state.modalOverlay = display;
    },

    [SET_APP_ID](state, { appId }) {
        state.appId = appId;
    },

    [SET_SHOW_API_PANEL](state, { showApiPanel }) {
        state.showApiPanel = showApiPanel;
    },

    [SET_SERVICE_STATUS](state, { service, status }) {
        const { services } = state.formData;
        const hasService = Object.prototype.hasOwnProperty.call(services, service);
        if (!hasService) {
            Vue.set(state.formData.services, service, {});
        }
        Vue.set(state.formData.services[service], 'status', status);
    },
    [SET_SERVICE_STATUS_REFERAL](state, { serviceReferal, statusReferal }) {
        const { servicesReferal } = state.formData;
        const hasServiceReferal = Object.prototype.hasOwnProperty.call(servicesReferal, serviceReferal);
        if (!hasServiceReferal) {
            Vue.set(state.formData.servicesReferal, serviceReferal, {});
        }
        Vue.set(state.formData.servicesReferal[serviceReferal], 'status', statusReferal);
    },

    [SET_MAX_LOAN](state, { maxLoan }) {
        state.formData.maxLoan = maxLoan;
    },

    [SET_MONTHLY_INSTALMENTS](state, { monthlyInstalmentsOptions }) {
        state.formData.monthlyInstalmentsOptions = monthlyInstalmentsOptions;
    },

    [SET_TRANSACTION_ID](state, { vendorIncomeVerificationId, duniaIncomeVerificationId }) {
        const { formData } = state;
        const transactions = formData[PERFIOS_TRANSACTION];
        Vue.set(transactions, 'duniaIncomeVerificationId', duniaIncomeVerificationId);
        Vue.set(transactions, 'vendorIncomeVerificationId', vendorIncomeVerificationId);
    },

    [SET_TRANSACTION_DECISION](state, { transactionStatus }) {
        const { formData } = state;
        const transactions = formData[PERFIOS_TRANSACTION];
        Vue.set(transactions, 'status', transactionStatus);
    },

    [RESET_TRANSACTION_DECISION](state) {
        const { formData } = state;
        const transactions = formData[PERFIOS_TRANSACTION];
        Vue.set(transactions, 'status', null);
    },

    [SET_INSTITUTIONS](state, { institutions }) {
        state.institutions = institutions;
    },
    [SET_OTHER](state, { other }) {
        state.other = other;
    },

    //--Begin-- Changes done By Attra
    [SET_QUERYSTRING](state, { querystrings }) {
        state.querystrings = querystrings;
    },
    [SET_CIF_NUMBER](state, { cifnumber }) {
        state.cifnumber = cifnumber;
    },

    [SET_INSTALMENT_AMOUNT](state, { monthlyInstalment }) {
        state.monthlyInstalment = monthlyInstalment;
    },

    [SET_UTM_SOURCE](state, { source }) {
        state.source = source;
    },
    [SET_UTM_MEDIUM](state, { medium }) {
        state.medium = medium;
    },
    [SET_UTM_CAMPAIGN](state, { campaign }) {
        state.campaign = campaign;
    },

    [SET_UTM_CONTENT](state, { content }) {
        state.content = content;
    },
    [SET_UTM_PRODUCT_ID](state, { productId }) {
        state.productId = productId;
    },
    [SET_BANK_NAME](state, { bankName }) {
        state.bankName = bankName;
    },
    [SET_CREDIT_SCORE_STATUS](state, { creditScoreStatus }) {
        state.creditScoreStatus = creditScoreStatus;
    },
    [SET_DOC_NUMBER](state, { docNumber }) {
        state.docNumber = docNumber;
    },
    [SET_DOC_TYPE](state, { docType }) {
        state.docType = docType;
    },
    [SET_FIRST_NAME](state, { firstName }) {
        state.firstName = firstName;
    },
    [SET_SECOND_NAME](state, { lastName }) {
        state.lastName = lastName;
    },

    [SET_BASIC_ELIGIBILITY](state, { basicEligibility5000 }) {
        state.basicEligibility5000 = basicEligibility5000;
    },
    [SET_PRODUCT_TYPE](state, { productType }) {
        state.productType = productType;
    },
    [SET_USE](state, { use }) {
        state.use = use;
    },
    [SET_HOW_MUCH](state, { howMuch }) {
        state.howMuch = howMuch;
    },
    [SET_INSTALMENT](state, { instalment }) {
        state.instalment = instalment;
    },
    [SET_CONSOLIDATED_STATEMENT_DATA](state, { consolidatedSatement }) {
        state.consolidatedSatement = consolidatedSatement;
    },
    [SET_STATEMENT_ONE_DATA](state, { statementOneData }) {
        state.statementOneData = statementOneData;
    },
    [SET_STATEMENT_TWO_DATA](state, { statementTwoData }) {
        state.statementTwoData = statementTwoData;
    },
    [SET_STATEMENT_THREE_DATA](state, { statementThreeData }) {
        state.statementThreeData = statementThreeData;
    },

    [SET_CREDIT_SCORE_CALCULATION_STATUS](state, { creditScoreCalculationSatus }) {
        state.creditScoreCalculationSatus = creditScoreCalculationSatus;
    },
    [SET_PRODCUT_FROM_URL](state, { productTypeFromUrl }) {
        state.productTypeFromUrl = productTypeFromUrl;
    },
    [SET_INELIGIBLE_EMIRATES](state, { ineligibleEmirates }) {
        state.ineligibleEmirates = ineligibleEmirates;
    },

    [SET_EMPLOYMENT_TYPE](state, { employmentType }) {
        state.employmentType = employmentType;
    },

    //NBC CARD

    [SET_SPENDING](state, { spending }) {
        state.spending = spending;
    },
    [SET_SALARY_RECEIVE](state, { salaryReceive }) {
        state.salaryReceive = salaryReceive;
    },
    [SET_REWARD_TYPE](state, { rewardType }) {
        state.rewardType = rewardType;
    },
    [SET_CASH_BACK_POINT](state, { cashBackPoint }) {
        state.cashBackPoint = cashBackPoint;
    },
    [SET_TEN_TO_TWENTY_FIVE](state, { tenToTwentyFive }) {
        state.tenToTwentyFive = tenToTwentyFive;
    },
    [SET_MORE_THAN_TWENTY_FIVE](state, { moreThanTwentyFive }) {
        state.moreThanTwentyFive = moreThanTwentyFive;
    },

    [SET_SERVICE_ERROR](state, { serviceError }) {
        state.serviceError = serviceError;
    },
    [SET_CARD_TYPE](state, { cardType }) {
        state.cardType = cardType;
    },
    [SET_LOAN_TYPE](state, { loanType }) {
        state.loanType = loanType;
    },
    [SET_PROMO_CODE_RESPONSE](state, { promoCodeResponse }) {
        state.promoCodeResponse = promoCodeResponse;
    },
    [SET_PROMO_CODE_STATUS](state, { promoCodeStatus }) {
        state.promoCodeStatus = promoCodeStatus;
    },
    [SET_BRANCH_CODES](state, { branchCodes }) {
        state.branchCodes = branchCodes;
    },
    [SET_EMPLOYEE_CODES](state, { employeeCodes }) {
        state.employeeCodes = employeeCodes;
    },
    [SET_PRODUCTS](state, { products }) {
        state.products = products;
    },
    [SET_INELIGIBLE_MEDIUM_OF_RECEIVE](state, { ineligibleMediumOfReceive }) {
        state.ineligibleMediumOfReceive = ineligibleMediumOfReceive;
    },
    [SET_APPIAN_PERSONAL_INFO_RESPONSE](state, { appianPersonalInfo }) {
        state.appianPersonalInfo = appianPersonalInfo;
    },
    [SET_APPIAN_IDENTITY_INFO_RESPONSE](state, { appianIdentityInfo }) {
        state.appianIdentityInfo = appianIdentityInfo;
    },
    [SET_APPIAN_EMP_INFO_RESPONSE](state, { appianEmpInfo }) {
        state.appianEmpInfo = appianEmpInfo;
    },
    [SET_APPIAN_INCOME_INFO_RESPONSE](state, { appianIncomeInfo }) {
        state.appianIncomeInfo = appianIncomeInfo;
    },
    [SET_PRODUCT_FROM_API_RESPONSE](state, { productTypeFromCreditScoreCalculation }) {
        state.productTypeFromCreditScoreCalculation = productTypeFromCreditScoreCalculation;
    },
    [SET_OFFER_REJECTED](state, { offerRejected }) {
        state.offerRejected = offerRejected;
    },
    [SET_IS_PERFIOS_ERROR](state, { isPerfiosError }) {
        state.isPerfiosError = isPerfiosError;
    },
    [SET_PERFIOS_ERROR_MESSAGE](state, { perfiosErrorMessage }) {
        state.perfiosErrorMessage = perfiosErrorMessage;
    },
    [SET_AGENT_MOBILE](state, { agentMobileNumber }) {
        state.agentMobileNumber = agentMobileNumber;
    },
    [SET_CARD_TYPE_APPIAN](state, { appianCardType }) {
        state.appianCardType = appianCardType;
    },
    [SET_STP_CARD_INCOME_NEXT](state, { incomeInfoNext }) {
        state.incomeInfoNext = incomeInfoNext;
    },
    [SET_PRE_SCREENED_AMOUNT](state, { preScreendedAmount }) {
        state.preScreendedAmount = preScreendedAmount;
    },
    [SET_VARIABLE_INCOME](state, { variableIncome }) {
        state.variableIncome = variableIncome;
    },
    [SET_STP_PRE_SCREENED_AMOUNT](state, { stpPreScreenedAmount }) {
        state.stpPreScreenedAmount = stpPreScreenedAmount;
    },
    [SET_CHANNEL](state, { channel }) {
        state.channel = channel;
    },
    [SET_ACCUITY_RESPONSE](state, { accuityResponse }) {
        state.accuityResponse = accuityResponse;
    },
    [SET_UAE_VINTAGE](state, { uaeVintage }) {
        state.uaeVintage = uaeVintage;
    },
    [SET_CIF_ERROR](state, { isCifError }) {
        state.isCifError = isCifError;
    },
    [SET_CUSTOMER_CONSENT](state, { customerConsent }) {
        state.customerConsent = customerConsent;
    },
    [SET_JOB_VINTAGE](state, { jobVintage }) {
        state.jobVintage = jobVintage;
    },
    [SET_CUSTOMER_EXIST](state, { customerExist }) {
        state.customerExist = customerExist;
    },
    [SET_CIF_ERROR_COUNT](state, { cifErrorCount }) {
        state.cifErrorCount = cifErrorCount;
    },
    [SET_CC_SCORE_RESPONSE](state, { ccScore }) {
        state.ccScore = ccScore;
    },
    [SET_APPLICATION_STATUS](state, { applicationStatus }) {
        state.applicationStatus = applicationStatus;
    },
    [SET_MAX_CREDIT_LIMIT](state, { maxCreditLimit }) {
        state.maxCreditLimit = maxCreditLimit;
    },
    [SET_REFERAL_CIF](state, { referalCif }) {
        state.referalCif = referalCif;
    },
    [SET_CREDIT_SCORE_CALCULATION_RES](state, { creditScoreCalculationRes }) {
        state.creditScoreCalculationRes = creditScoreCalculationRes;
    },
    [SET_ADDRESS_COUNT](state, { addressCount }) {
        state.addressCount = addressCount;
    },
    [SET_BUREAU_SCORE](state, { bureauScore }) {
        state.bureauScore = bureauScore;
    },
    [SET_INCOME_FIXED](state, { incomeFixed }) {
        state.incomeFixed = incomeFixed;
    },
    [SET_BANK_NAMES](state, { bankList }) {
        state.bankList = bankList;
    },
    [SET_BT_TRANSFER_LIMIT](state, { btTrnsferLimit }) {
        state.btTrnsferLimit = btTrnsferLimit;
    },
    [SET_LIMIT_EXCEEDED](state, { limitExceeded }) {
        state.limitExceeded = limitExceeded;
    },
    [SET_AUTOMATION_RESPONSE](state, { automationResponse }) {
        state.automationResponse = automationResponse;
    },
    [SET_DEEMGUARD_CREDITLIFEPLUS](state, { deemGuardCreditLife }) {
        state.deemGuardCreditLife = deemGuardCreditLife;
    },
    [SET_DEEM_DOUBLESECURE_LOANPROTECT](state, { deemDoubleSecureLoanProtect }) {
        state.deemDoubleSecureLoanProtect = deemDoubleSecureLoanProtect;
    },

    [ADD_BALANCE_TRANSFER](state, {

        bankName,
        creditCardNumber,
        cardLimit,
        btRequestAmount,
        btType


    }) {
        state.formData.balanceTransfers.push({

            bankName,
            creditCardNumber,
            cardLimit,
            btRequestAmount,
            btType

        });
    },

    [EDIT_BALANCE_TRANSFER](state, {
        index,
        bankName,
        creditCardNumber,
        cardLimit,
        btRequestAmount,
        btType

    }) {
        state.formData.balanceTransfers[index] = {

            bankName,
            creditCardNumber,
            cardLimit,
            btRequestAmount,
            btType

        };
    },
    [REMOVE_BALANCE_TRANSFER](state, cardIndex) {
        Vue.delete(state.formData.balanceTransfers = state.formData.balanceTransfers, cardIndex);
    },
    //Balance Transfer

    //--End-- Changes done By Attra
    [SET_UPLOADED_OCR](state, { OCRUpdatedFields, idInfo }) {
        state.formData.OCRUpdatedFields = OCRUpdatedFields;
        state.formData.services.idInfo = idInfo;
    },

    [SET_LAST_VISITED_PAGE](state, { lastVisitedPage }) {
        state.lastVisitedPage = lastVisitedPage;
    },

    [ADD_SUPPLEMENTARY_CARD](state, {
        firstName,
        lastName,
        gender,
        dateOfBirth,
        nationality,
        relationship,
        passportID,
        nameOnCard,
        limit,
    }) {
        state.formData.supplementaryCards.push({
            firstName,
            lastName,
            gender,
            dateOfBirth,
            nationality,
            relationship,
            passportID,
            nameOnCard,
            limit,
        });
    },

    [EDIT_SUPPLEMENTARY_CARD](state, {
        index,
        firstName,
        lastName,
        gender,
        dateOfBirth,
        nationality,
        relationship,
        passportID,
        nameOnCard,
        limit,
    }) {
        state.formData.supplementaryCards[index] = {
            firstName,
            lastName,
            gender,
            dateOfBirth,
            nationality,
            relationship,
            passportID,
            nameOnCard,
            limit,
        };
    },
    [REMOVE_SUPPLEMENTARY_CARD](state, cardIndex) {
        Vue.delete(state.formData.supplementaryCards = state.formData.supplementaryCards, cardIndex);
    },

    [SET_CURRENT_PRODUCT](state, { product }) {
        state.formData.product = product;
    },
};

export {
    formsState,
    formsMutations,
};